// Maps backend English error strings to translation keys
const ERROR_MAP = {
  'Invalid credentials': 'error.invalidCredentials',
  'Too many login attempts. Please try again in 10 minutes.': 'error.tooManyAttempts',
  'Account is disabled': 'error.accountDisabled',
  'Company account is disabled. Contact support.': 'error.companyDisabled',
  'Trial period has expired. Please contact support to activate your subscription.': 'error.trialExpired',
  'Token expired. Please log in again.': 'error.tokenExpired',
  'Invalid token': 'error.invalidToken',
  'User not found': 'error.userNotFound',
  'Email already in use': 'error.emailInUse',
  'Wrong current password': 'error.wrongPassword',
  'Password must be at least 8 characters': 'error.passwordTooShort',
  'Password must be at least 6 characters': 'error.passwordTooShort',
  'Invalid or expired invite link': 'error.invalidInvite',
  'Invite link expired': 'error.inviteExpired',
  'Invalid or expired token': 'error.invalidToken',
  'Token expired': 'error.tokenExpired',
  'This email address is already registered. Please use a different email or log in.': 'error.emailAlreadyRegistered',
  'A company with this email is already registered': 'error.companyEmailTaken',
  'Company with this email already exists': 'error.companyEmailTaken',
  'Administrator name is required': 'error.adminNameRequired',
  'Company name is required': 'error.companyNameRequired',
  'Invalid email address format': 'error.invalidEmail',
  'Company has reached maximum employee limit': 'error.maxEmployeesReached',
  'User with this email already exists': 'error.userEmailExists',
  'This email is already registered in the system': 'error.userEmailExists',
  'Self-registration is not available. Please ask your company administrator to create your account, or register your company at /register-company.': 'error.selfRegNotAvailable',
  'Nothing to update': 'error.nothingToUpdate',
  'Cannot delete your own account': 'error.cannotDeleteSelf',
  'Cannot remove the last admin of the company': 'error.cannotRemoveLastAdmin',
  'No company associated with this user': 'error.noCompany',
  'Company not found': 'error.companyNotFound',
};

/**
 * Translates a backend API error message using the provided t() function.
 * Falls back to the original message if no translation found.
 * @param {Error|string} errorOrMessage - axios error or raw string
 * @param {Function} t - translation function from useLanguage()
 * @param {string} [fallback] - fallback message if nothing matches
 */
export function translateApiError(errorOrMessage, t, fallback) {
  let msg;
  if (typeof errorOrMessage === 'string') {
    msg = errorOrMessage;
  } else {
    const detail = errorOrMessage?.response?.data?.detail;
    if (typeof detail === 'string') {
      msg = detail;
    } else if (Array.isArray(detail) && detail[0]?.msg) {
      msg = detail[0].msg;
    } else {
      return fallback || (t ? t('msg.error') : 'Error occurred');
    }
  }

  const key = ERROR_MAP[msg];
  if (key && t) {
    const translated = t(key);
    if (translated !== key) return translated;
  }

  return msg || fallback || (t ? t('msg.error') : 'Error occurred');
}
